var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTimesheetGeneralApproved = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M2.75 10.0006C2.75 11.9235 3.5139 13.7677 4.87364 15.1275C6.23338 16.4872 8.07759 17.2511 10.0006 17.2511C11.9235 17.2511 13.7677 16.4872 15.1275 15.1275C16.4872 13.7677 17.2511 11.9235 17.2511 10.0006C17.2511 8.07759 16.4872 6.23338 15.1275 4.87364C13.7677 3.5139 11.9235 2.75 10.0006 2.75C8.07759 2.75 6.23338 3.5139 4.87364 4.87364C3.5139 6.23338 2.75 8.07759 2.75 10.0006Z",
  fill: "#46CC88"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M2 10.0006C2 12.1224 2.84291 14.1574 4.34331 15.6578L5.40397 14.5971C4.18488 13.3781 3.5 11.7246 3.5 10.0006H2ZM4.34331 15.6578C5.84371 17.1582 7.87868 18.0011 10.0006 18.0011V16.5011C8.2765 16.5011 6.62306 15.8162 5.40397 14.5971L4.34331 15.6578ZM10.0006 18.0011C12.1224 18.0011 14.1574 17.1582 15.6578 15.6578L14.5971 14.5971C13.3781 15.8162 11.7246 16.5011 10.0006 16.5011V18.0011ZM15.6578 15.6578C17.1582 14.1574 18.0011 12.1224 18.0011 10.0006H16.5011C16.5011 11.7246 15.8162 13.3781 14.5971 14.5971L15.6578 15.6578ZM18.0011 10.0006C18.0011 7.87868 17.1582 5.84371 15.6578 4.34331L14.5971 5.40397C15.8162 6.62306 16.5011 8.2765 16.5011 10.0006H18.0011ZM15.6578 4.34331C14.1574 2.84291 12.1224 2 10.0006 2V3.5C11.7246 3.5 13.3781 4.18488 14.5971 5.40397L15.6578 4.34331ZM10.0006 2C7.87868 2 5.84371 2.84291 4.34331 4.34331L5.40397 5.40397C6.62306 4.18488 8.2765 3.5 10.0006 3.5V2ZM4.34331 4.34331C2.84291 5.84371 2 7.87868 2 10.0006H3.5C3.5 8.2765 4.18488 6.62306 5.40397 5.40397L4.34331 4.34331Z",
  fill: "#46CC88"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M13.2102 8L9.77319 11.9996",
  stroke: "white",
  strokeWidth: 1.5,
  strokeLinecap: "round"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M9.77165 12L8 9.93835",
  stroke: "white",
  strokeWidth: 1.5,
  strokeLinecap: "round"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgTimesheetGeneralApproved);
export default ForwardRef;